document.querySelectorAll('.hero-slider__items').forEach((slider) => {
    slider.classList.add('owl-carousel');

    const $slider = $(slider);
    const slideCount = $slider.children().length;

    $slider.owlCarousel({
        loop: slideCount > 1,
        margin: 0,
        nav: false,
        dots: slideCount > 1,
        autoplay: slideCount > 1,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        items: 1,
    });
});
